
import { validateRuls } from 'mixins'

export default {
  mixins: [ validateRuls ],
  computed: {
    $_options_yes_or_no() {
      return [
        {value: true, label: this.$t('Tenders.Yes') },
        {value: false, label: this.$t('Tenders.No') },
      ]
    },
    additional_types() {
      let items =  this.$store.getters.getAdditionalFieldsTypes
      if (!items?.length) {
        return []
      }
      return items.map(item => ({...item, icon: this.$_getIconByType(item)}))
    },
  },
  methods: {
    $_getValidationByType(type, required = true) {
      const that = this
      let validation = ''
      let textValidation = (max = 1500)  => {
        return [

          that.$_validateRequired(required),
          {
            type: 'string',
            required,
            trigger: 'change',
            transform(value) {
              return value?.trim()
            },
            max: max,
            message: that.$t('Validate.maxLength', {number: max, type: that.$tc('Common.characters', 10) })
          }
        ]
      }

      switch (type) {
      case 'CHECKBOX' : {
        validation = [
          that.$_validateRequired(required, 'boolean')
        ]
        break
      }
      case 'DATE_TIME': {
        validation = [
          that.$_validateRequired(required, 'date')
        ]
        break
      }
      case 'TEXT': {
        validation = textValidation(4000)
        break
      }
      case 'STRING': {
        validation = textValidation(254)
        break
      }
      case 'INTEGER':
      case 'DECIMAL': {
        validation =  [
          that.$_validateRequired(required, 'number')
        ]
        break
      }
      case 'URL': {
        validation = that.$_linkValidation(required, 'url')
        break
      }
      case 'DROPDOWN': {
        validation = [
          that.$_validateRequired(required)
        ]
        break
      }
      case 'PHONE': {
        validation = that.$_phoneValidation(required)
        break
      }
      case 'EMAIL': {
        validation = that.$_emailValidation(required, 'email')
        break
      }
      default: {
        validation = [
          that.$_validateRequired(required)
        ]
        break
      }
      }
      return validation
    },
    $_emailValidation(required = true) {
      const that = this
      return  [
        that.$_validateRequired(required),
        that.$_validateMinMax(2, 254),
        {
          type: 'string',
          required: required,
          trigger: 'blur',
          pattern: /^\s*([A-Za-z0-9_\-.'])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,10})\s*$/,
          message: that.$t('Tenders.MailRules', {mail: ''})
        }]
    },
    $_linkValidation(required = true) {
      const that = this
      return  [
        that.$_validateRequired(required),
        that.$_validateMinMax(2, 254),
        {
          type: 'string',
          required: required,
          trigger: 'blur',
          pattern: /^(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\\/~+#-]*[\w@?^=%&amp;\\/~+#-])?$/,
          message: that.$t('Validate.LinkRules')
        }]
    },
    $_phoneValidation(required = true) {
      const that = this
      return  [
        that.$_validateRequired(required),
        that.$_validateMinMax(2, 254),
        {
          type: 'string',
          required: required,
          trigger: 'blur',
          pattern: /^\+\d{12}$/,
          message: that.$t('Tenders.PhoneNumRules')
        }]
    },
    $_addAdditionalFieldsToHeaders(headers, fields, last = true, additionalKey = 'AdditionalFields.') {
      if (!headers?.length) {
        return []
      }

      // сортируем по пришедшему порядку и перенумеровываем, что б исключить дубли
      const result = this.$_.cloneDeep(headers).map((i, index) => ({...i, order: i.order ? i.order : index + 1}))
      fields = (fields || [])
        .sort((a,b) => a.order - b.order)
        .map((i, index) => ({
          ...i,
          order: index + 1
        }))

      const maxOrder = Math.max(
        ...(result ?? [])
          .filter(i => i.value !== 'menuWithAdditionalField').map(i => i.order)
          .concat([0])
      )

      this.$_.cloneDeep(fields).forEach((field) => {
        if (!field) {
          return
        }
        const index = result.findIndex(el => el.value == additionalKey + field.id)
        if (index == -1 ) {
          let headerItem = {
            text: field.caption,
            value: additionalKey + field.id,
            sortable: false,
            field,
            required: field.settingValues?.find(i => i.settingType === 'REQUIRED')?.value === 'true',
            order: maxOrder + field.order
          }
          if (last) {
            result.push(headerItem) //todo only id needed
          } else {
            result.splice(-1, 0, headerItem)
          }
        } else {
          result[index].text = field.caption
          result[index].showForBidders = field.showForBidders
          result[index].order = maxOrder + field.order
        }
      })

      return result
        .filter(headerItem =>
          !headerItem.value.includes(additionalKey) ||
          fields.some(
            el =>  headerItem.value.includes( el.id )
          )
        )
        .sort((a, b) => a.order - b.order) // якшо якесь поле видадлили
    },
    $_changeFieldType(type, options, rules ) {
      if ( type.typeId == 'DROPDOWN' ) {
        this.$_addAOption(options, rules)
        this.$_addAOption(options, rules)
      } else {
        options = []
      }
    },
    $_addAOption(options, rules ) {
      const that = this
      const prefix = `options[${options?.length }].value`

      options.push({
        value: '',
        id: '00000000-0000-0000-0000-000000000000'
      })
      rules[prefix] = [
        {
          type: 'string',
          required: true,
          trigger: 'change',
          transform(value) {
            return value?.trim()
          },
          max: 4000,
          message: that.$t('Validate.maxLength', {number: 4000, type: that.$tc('Common.characters', 10) })
        }
      ]
    },
    $_deleteOption(index, options) {
      options.splice(index, 1)
    },
    $_getIconByType(item) {
      let icon = ''

      switch (item.typeId) {
      case 'CHECKBOX' : {
        icon = 'checkbox'
        break
      }
      case 'DATE_TIME': {
        icon = 'calendar'
        break
      }
      case 'TEXT': {
        icon = 'text'
        break
      }
      case 'STRING': {
        icon = 'hyphen'
        break
      }
      case 'DECIMAL': {
        icon = 'sharp'
        break
      }
      case 'URL': {
        icon = 'world'
        break
      }
      case 'DROPDOWN': {
        icon = 'dropdown'
        break
      }
      case 'PHONE': {
        icon = 'phone'
        break
      }
      case 'EMAIL': {
        icon = 'mail'
        break
      }
      default: {
        icon = 'crossed'
        break
      }
      }
      return icon
    },
  },
}
